import React from 'react'

const Skeleton = ({classes}) => {
  // rounded-lg
  return (
    <div className={`animate-pulse bg-gray-300  ${classes}`}></div>
  )
}

export default Skeleton